import { takeLatest, put, call } from 'redux-saga/effects';
//  SagaReturnType is a type; imported as a value it trips import/named.
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_GET_THERAPIST_FILTERS,
  SUCCESS_GET_THERAPIST_FILTERS,
  FAILURE_GET_THERAPIST_FILTERS,
  LOADING_GET_THERAPIST_FILTERS,
} = documentBundleActions;

function* getTherapistFilters(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_THERAPIST_FILTERS });
    const response = yield call(documentBundleService.getTherapistFilters, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_THERAPIST_FILTERS, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_THERAPIST_FILTERS, payload: error });
  }
}

function* getTherapistFiltersSaga() {
  yield takeLatest(REQUEST_GET_THERAPIST_FILTERS, getTherapistFilters);
}

export default getTherapistFiltersSaga;
export { getTherapistFilters };
